import React from 'react';
import { Container, Box, Typography, Paper } from '@mui/material';

const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ mb: 4 }}>
          Privacy Policy
        </Typography>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            1. Informazioni Generali
          </Typography>
          <Typography variant="body1" paragraph>
            La presente Privacy Policy descrive come vengono raccolti, utilizzati e protetti i dati personali degli utenti 
            che utilizzano i servizi dell'associazione. Il trattamento dei dati personali è effettuato nel rispetto del 
            Regolamento Generale sulla Protezione dei Dati (GDPR - Regolamento UE 2016/679) e della normativa italiana 
            applicabile in materia di protezione dei dati personali.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            2. Titolare del Trattamento
          </Typography>
          <Typography variant="body1" paragraph>
            Il titolare del trattamento dei dati personali è l'associazione, con sede legale indicata nei documenti 
            ufficiali dell'ente. Per qualsiasi richiesta relativa al trattamento dei dati personali, è possibile 
            contattare il titolare tramite i canali di comunicazione indicati sul sito web.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            3. Dati Raccolti
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali raccolti includono, ma non si limitano a:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4, mb: 2 }}>
            <li>Dati anagrafici (nome, cognome, data di nascita)</li>
            <li>Dati di contatto (indirizzo email, numero di telefono)</li>
            <li>Dati relativi all'iscrizione e alla partecipazione alle attività dell'associazione</li>
            <li>Dati di pagamento (per le transazioni effettuate attraverso i servizi dell'associazione)</li>
            <li>Dati di navigazione e utilizzo del sito web</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            4. Finalità del Trattamento
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali vengono trattati per le seguenti finalità:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4, mb: 2 }}>
            <li>Gestione delle iscrizioni e delle attività dell'associazione</li>
            <li>Comunicazione con gli iscritti riguardo alle attività e agli eventi</li>
            <li>Gestione dei pagamenti e delle transazioni finanziarie</li>
            <li>Adempimento degli obblighi di legge e normativi</li>
            <li>Miglioramento dei servizi offerti</li>
            <li>Prevenzione di frodi e abusi</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            5. Base Giuridica del Trattamento
          </Typography>
          <Typography variant="body1" paragraph>
            Il trattamento dei dati personali si basa su:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4, mb: 2 }}>
            <li>Consenso dell'interessato</li>
            <li>Esecuzione di un contratto o di misure precontrattuali</li>
            <li>Adempimento di obblighi di legge</li>
            <li>Legittimo interesse del titolare</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            6. Conservazione dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali vengono conservati per il periodo necessario al perseguimento delle finalità per cui sono 
            stati raccolti, nel rispetto dei termini di conservazione previsti dalla normativa applicabile. Al termine 
            del periodo di conservazione, i dati vengono cancellati o anonimizzati in modo sicuro.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            7. Comunicazione e Diffusione dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            I dati personali non vengono comunicati a terzi né diffusi, salvo nei seguenti casi:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4, mb: 2 }}>
            <li>Quando la comunicazione è necessaria per l'erogazione dei servizi richiesti</li>
            <li>Quando è richiesto dalla legge o da un'autorità competente</li>
            <li>Con il consenso esplicito dell'interessato</li>
            <li>Per la gestione di pagamenti attraverso servizi di terze parti (es. PayPal, Stripe)</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            8. Diritti dell'Interessato
          </Typography>
          <Typography variant="body1" paragraph>
            Ai sensi del GDPR, l'interessato ha diritto di:
          </Typography>
          <Typography component="ul" variant="body1" sx={{ pl: 4, mb: 2 }}>
            <li>Accedere ai propri dati personali</li>
            <li>Ottenere la rettifica dei dati inesatti o incompleti</li>
            <li>Richiedere la cancellazione dei dati (diritto all'oblio)</li>
            <li>Opporsi al trattamento dei dati</li>
            <li>Richiedere la limitazione del trattamento</li>
            <li>Richiedere la portabilità dei dati</li>
            <li>Revocare il consenso in qualsiasi momento</li>
            <li>Proporre reclamo all'Autorità Garante per la protezione dei dati personali</li>
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            9. Sicurezza dei Dati
          </Typography>
          <Typography variant="body1" paragraph>
            L'associazione adotta misure tecniche e organizzative appropriate per garantire la sicurezza dei dati personali, 
            prevenendo la perdita, l'uso improprio, l'accesso non autorizzato e la divulgazione dei dati. Tuttavia, nessun 
            sistema di trasmissione o archiviazione di dati è completamente sicuro, pertanto non è possibile garantire una 
            sicurezza assoluta.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            10. Cookie e Tecnologie Simili
          </Typography>
          <Typography variant="body1" paragraph>
            Il sito web utilizza cookie e tecnologie simili per migliorare l'esperienza dell'utente e per analizzare 
            l'utilizzo del sito. Per maggiori informazioni sull'utilizzo dei cookie, si prega di consultare la Cookie Policy.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            11. Modifiche alla Privacy Policy
          </Typography>
          <Typography variant="body1" paragraph>
            L'associazione si riserva il diritto di modificare la presente Privacy Policy in qualsiasi momento. Le modifiche 
            saranno pubblicate su questa pagina con la data di aggiornamento. Si consiglia di consultare periodicamente 
            questa pagina per essere informati su eventuali modifiche.
          </Typography>
        </Box>

        <Box sx={{ mb: 4 }}>
          <Typography variant="h6" gutterBottom>
            12. Contatti
          </Typography>
          <Typography variant="body1" paragraph>
            Per esercitare i propri diritti o per qualsiasi richiesta relativa al trattamento dei dati personali, è possibile 
            contattare il titolare del trattamento tramite i canali di comunicazione indicati sul sito web dell'associazione.
          </Typography>
        </Box>

        <Box sx={{ mt: 4, pt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default PrivacyPolicy;
